import {apiRequest} from "../action/api.action"
import { FETCH_FLEETS_DATA, FETCH_FLEETS_FAILURE, FETCH_FLEETS_SUCCESS, UPDATE_FLEET_FOR_MAP, ADD_VESSEL_TO_FLEET, ADD_VESSEL_TO_FLEET_SUCCESS, ADD_VESSEL_TO_FLEET_FAILURE, fetchFleetsData, REMOVE_VESSEL_FROM_FLEET, REMOVE_VESSEL_FROM_FLEET_FAILURE, REMOVE_VESSEL_FROM_FLEET_SUCCESS, ADD_SHIPYARD_TO_WATCHLIST, ADD_SHIPYARD_TO_WATCHLIST_SUCCESS, ADD_SHIPYARD_TO_WATCHLIST_FAILURE, REMOVE_SHIPYARD_FROM_WATCHLIST_SUCCESS, REMOVE_SHIPYARD_FROM_WATCHLIST_FAILURE, REMOVE_SHIPYARD_FROM_WATCHLIST } from "../action/fleet.action";
import { FETCH_MAP_DATA_SUCCESS, FETCH_MAP_DATA_FAILURE } from "../action/map-data.action";
import {dismiss, update, error, message, warning, success, info} from 'react-toastify-redux';
import { FETCH_ALERT_HISTORY, FETCH_ALERT_HISTORY_FAILURE, FETCH_ALERT_HISTORY_SUCCESS } from "../action/alert.action";

export const alertFlow = ({dispatch}) => next => action => {

  next(action)
  
  if(action.type === FETCH_ALERT_HISTORY) {
    let url = `/api/v1/alerting/history`;
    dispatch(apiRequest('GET', url, null, FETCH_ALERT_HISTORY_SUCCESS, FETCH_ALERT_HISTORY_FAILURE));
  } 
};

export const alertMdl = [alertFlow];